import React from "react";
import LegalMaterial from "../../components/LegalMaterial";
import text from "../../locales/ru/ru.json";
import "./style.scss";
import { useTranslation } from "react-i18next";
import isPayplusDomain from "../../utils/isPayplusDomain";
import getPolicyLinks from "../../utils/getPolicyLinks";

export default function Conditions() {
  const { t } = useTranslation();
  const { gameSites, gameRules } = getPolicyLinks();
  const tParams = { gameSites, gameRules };
  const payplus = isPayplusDomain();
  // На .com/.space подменяем все формы юр. имени РФ-ИП на иностранную компанию.
  // На .ru возвращаем строку как есть, сохраняя оригинальную грамматику падежей.
  const applyLicensor = (str) => {
    if (!payplus || !str) return str;
    return str.replace(
      /ИП Рашевск\S+\s+(?:Л\.?К\.?|Любовь Константиновна)\.?/g,
      "Осек Патур Дарья Рашевская"
    );
  };

  const renderTitle = (keyTwoLevel, keyThreeLevel) => {
    if (keyThreeLevel) {
      return (
        <div className="conditions-page__content__title__sub">
          {applyLicensor(t(`${keyTwoLevel}.${keyThreeLevel}.title`, tParams))}
        </div>
      );
    }
    return (
      <div className="conditions-page__content__title">
        {applyLicensor(t(`${keyTwoLevel}.title`, tParams))}
      </div>
    );
  };
  const renderTwoLevelParagraph = (keyTwoLevel, keyThreeLevel) => {
    if (keyThreeLevel) {
      return (
        <div className="conditions-page__content__subtitles conditions-page__content__subtitles">
          {renderTitle(keyTwoLevel, keyThreeLevel)}
          {text[keyTwoLevel][keyThreeLevel]?.text?.map((txt, i) => {
            return (
              <div
                key={i}
                className="conditions-page__content__subtitles__subtitle conditions-page__content__subtitles__subtitle_three-level"
              >
                {applyLicensor(
                  t(`${keyTwoLevel}.${keyThreeLevel}.text.${i}.desc`, tParams)
                )}
              </div>
            );
          })}
        </div>
      );
    }
    return (
      <div className="conditions-page__content">
        {renderTitle(keyTwoLevel)}
        {text[keyTwoLevel]?.text.map((txt, i) => {
          return (
            <div
              key={i}
              className="conditions-page__content__subtitles__subtitle"
            >
              {applyLicensor(t(`${keyTwoLevel}.text.${i}.desc`, tParams))}
            </div>
          );
        })}
      </div>
    );
  };
  return (
    <LegalMaterial header={t("condition_title")}>
      <div className="conditions-page">
        <div className="conditions-page__head">
          <div>{applyLicensor(t("head_1", tParams))}</div>
          <br />
          <div>{applyLicensor(t("head_2", tParams))}</div>
          <br />
          <div>{applyLicensor(t("condition_tip", tParams))}</div>
        </div>
        <br />
        <div className="conditions-page__content">
          {renderTwoLevelParagraph("1_terms_agreement")}
          {renderTwoLevelParagraph("2_condition_sign_agreement")}
          {renderTwoLevelParagraph("3_subject_of_agreement")}
          {renderTitle("4_game_use_borders")}
          {renderTwoLevelParagraph("4_game_use_borders", "4_1_users_rights")}
          {renderTwoLevelParagraph("4_game_use_borders", "4_2_restrictions")}
          {renderTwoLevelParagraph("5_conditions_and_require_on_use")}
          {renderTitle("6_user_responsibilities")}
          {renderTwoLevelParagraph(
            "6_user_responsibilities",
            "6.1_user_response"
          )}
          {renderTwoLevelParagraph(
            "6_user_responsibilities",
            "6.2_user_not_right"
          )}
          {renderTitle("7_rights_and_responsibilities_IP")}
          {renderTwoLevelParagraph(
            "7_rights_and_responsibilities_IP",
            "7.1_IP_response"
          )}
          {renderTwoLevelParagraph(
            "7_rights_and_responsibilities_IP",
            "7.2_IP_in_right"
          )}
          {renderTitle("8_limitation_of_liability_IP")}
          {renderTwoLevelParagraph(
            "8_limitation_of_liability_IP",
            "8_1_lack_of_responsibility"
          )}
          {renderTwoLevelParagraph(
            "8_limitation_of_liability_IP",
            "8_2_no_guarantees"
          )}
          {renderTwoLevelParagraph(
            "8_limitation_of_liability_IP",
            "8_3_limitation_of_liability"
          )}
          {renderTwoLevelParagraph(
            "8_limitation_of_liability_IP",
            "8_4_force_majeure"
          )}
          {renderTitle("9_rights_to")}
          {renderTwoLevelParagraph("9_rights_to", "9_1_general_provisions")}
          {renderTwoLevelParagraph("9_rights_to", "9_3_fee_amount")}
          {renderTwoLevelParagraph(
            "9_rights_to",
            "9_4_payment_procedures_and_methods"
          )}
          {renderTwoLevelParagraph("9_rights_to", "9_5_payment_methods")}
          {renderTwoLevelParagraph(
            "9_rights_to",
            "9_6_consequences_of_misconduct"
          )}
          {renderTwoLevelParagraph(
            "9_rights_to",
            "9_7_inadmissibility_of_acquiring_rights"
          )}
          {renderTwoLevelParagraph(
            "9_rights_to",
            "9_8_Tracking_the_status_of_your_account"
          )}
          {renderTwoLevelParagraph(
            "9_rights_to",
            "9_9_Termination_of_the_right_of_use"
          )}
          {renderTwoLevelParagraph("9_rights_to", "9_10_exchange")}
          {renderTwoLevelParagraph(
            "9_rights_to",
            "9_11_reimbursement_of_expenses"
          )}
          {renderTwoLevelParagraph("9_rights_to", "9_12_gifts")}
          {renderTitle("10_intellectual_property_rights")}
          {renderTwoLevelParagraph(
            "10_intellectual_property_rights",
            "10_1_exclusive_right"
          )}
          {renderTwoLevelParagraph(
            "10_intellectual_property_rights",
            "10_2_exclusive_right_of_the_user"
          )}
          {renderTwoLevelParagraph(
            "10_intellectual_property_rights",
            "10_3_trademarks"
          )}
          {renderTitle("11_validity_period")}
          {renderTwoLevelParagraph(
            "11_validity_period",
            "11_1_duration_of_the_agreement"
          )}
          {renderTwoLevelParagraph(
            "11_validity_period",
            "11_2_amendment_of_the_agreement"
          )}
          {renderTwoLevelParagraph(
            "11_validity_period",
            "11_3_users_disagreement"
          )}
          {renderTwoLevelParagraph(
            "11_validity_period",
            "11_4_termination_of_the_agreement"
          )}
          {renderTwoLevelParagraph(
            "11_validity_period",
            "11_5_termination_by_user"
          )}
          {renderTwoLevelParagraph(
            "11_validity_period",
            "11_6_change_main_docs"
          )}
          {renderTitle("12_final_provisions")}
          {renderTwoLevelParagraph("12_final_provisions", "12_1_invalidity")}
          {renderTwoLevelParagraph(
            "12_final_provisions",
            "12_2_dispute_resolution"
          )}
        </div>
      </div>
    </LegalMaterial>
  );
}
